module.exports = __webpack_public_path__ + "static/media/company.8acc0b70.svg";